/** URL nhạc nền quiz (file trong `public/audio/quiz-ambient.mp3`, tôn trọng Vite base). */
export function getQuizBgmUrl() {
  const base = import.meta.env.BASE_URL || '/';
  const normalized = base.endsWith('/') ? base : `${base}/`;
  return `${normalized}audio/quiz-ambient.mp3`;
}
